<div class="page" [class.minimized]="minimized()">
  <div class="header">
    <h2 class="header-title">
      <mat-icon>schedule</mat-icon>
      Automatisch Plannen
    </h2>
    @if (isSuperUser || isAdmin || isPlanner) {
      <div class="button-wrapper">
        <button
          mat-flat-button
          class="secondary-color plan-button reset-button"
          (click)="resetAutomaticRides()"
          [disabled]="isResetting()"
        >
          @if (isResetting()) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <span>Automatisch plannen resetten</span>
          }
        </button>
      </div>
      <div class="button-wrapper">
        <button
          mat-flat-button
          class="secondary-color plan-button"
          (click)="planAutomaticRides()"
          [disabled]="isResetting()"
        >
          Automatisch plannen starten
        </button>
      </div>
      <div class="button-wrapper">
        <button
          mat-icon-button
          class="secondary-color plan-button icon-button"
          aria-label="Automatisch plannen starten"
          matTooltip="Automatisch plannen starten"
          (click)="planAutomaticRides()"
          [disabled]="isResetting()"
        >
          <mat-icon>calendar_today</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="content">
    <mat-tab-group class="rides-tabs" [selectedIndex]="selectedIndex">
      <mat-tab label="Ritten">
        <div class="rides-container">
          <div class="rides-list">
            @for (ride of filteredPlannedRides(); track ride.id) {
              <app-auto-plan-item [ride]="ride" (itemClicked)="editRide(ride)"></app-auto-plan-item>
            }

            @if (plannedRides().length === 0) {
              <div class="no-rides">
                <p>Geen ritten gevonden voor deze dag</p>
              </div>
            } @else if (plannedRides().length > 0 && filteredPlannedRides().length === 0) {
              <div class="no-rides">
                <p>Geen ritten gevonden voor deze dag met de huidige zoekopdracht</p>
              </div>
            }
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span
            [matBadge]="unassignedRides().length > 0 && unassignedRides().length < 10 ? unassignedRides().length : '9+'"
            [matBadgeHidden]="unassignedRides().length === 0"
            matBadgeColor="warn"
            matBadgeOverlap="false"
          >
            Restritten
          </span>
        </ng-template>
        <div class="rides-container">
          <div class="rides-list">
            @for (unassignedRide of filteredUnassignedRides(); track unassignedRide.id) {
              <app-auto-plan-item
                [ride]="unassignedRide"
                (itemClicked)="editRide(unassignedRide)"
                (deleteClicked)="deleteUnassignedRide(unassignedRide.id)"
              ></app-auto-plan-item>
            }

            @if (unassignedRides().length === 0) {
              <div class="no-rides">
                <p>Geen restritten gevonden voor deze dag</p>
              </div>
            } @else if (unassignedRides().length > 0 && filteredUnassignedRides().length === 0) {
              <div class="no-rides">
                <p>Geen restritten gevonden voor deze dag met de huidige zoekopdracht</p>
              </div>
            }
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
